export default {

  getBuilderInfo: state => {
    return state.builder
  },
  getCurrentInfo: state => {
    return state.current
  },
  getRedeSocial: state => {
    return state.redeSocial
  },
  getSiteContent: state => {
    return state.siteContent
  },
  getBlocos: state => {
    return state.blocos
  },
};


// WEBPACK FOOTER //
// ./src/store/getters.js